<script setup lang="ts">
const { variant = "transparent" } = defineProps<{ variant?: "light" | "transparent" }>()

const route = useRoute()
const searchQuery = ref(route.query.q ?? "")

const isOnline = useOnline()

function submitSearch() {
  const q = searchQuery.value

  return navigateTo({ name: `${isOnline.value ? "search" : "search-offline"}`, query: { q } })
}
</script>

<template>
  <form
    class="flex rounded-md border-2 border-white focus-within:border-light"
    :class="{
      'text-white bg-transparent hover:border-lighter': variant === 'transparent',
      'text-darker bg-white': variant === 'light',
  }"
    role="search"
    @submit.prevent="submitSearch()"
  >
    <label class="sr-only" for="searchbar">Søk</label>
    <input
      id="searchbar"
      v-model="searchQuery"
      style="color: inherit"
      class="flex-1 w-full px-4 py-2 font-national2 focus:outline-none"
      placeholder="Søk i alt innhold"
      type="text"
      data-pendo="USearchBar-input"
    />
    <button
      class="flex-none p-2 rounded-md"
      data-pendo="USearchBar-submit"
      aria-label="utfør søk"
    >
      <u-icon style="stroke: currentColor" name="search" size="sm" />
    </button>
    <p class="sr-only">
      Resultatene blir oppdatert når du klikker på søkeknappen, eller når du endrer på søkefilter.
    </p>
  </form>
</template>
